import React from 'react';
import OperationConsultation from './OperationConsultation';
import OperationOffre from './OperationOffre';
import { useOperationBCIActions } from '../hooks/useOperationBCIActions';
import { buildConsultationLaunchBody } from '../domain/operationConsultation';
import { lancerConsultation } from '../services/operationBciService';
import { TabDescriptor, OperationBCI } from '../types';

interface OperationContentProps {
  operation: OperationBCI;
  setOperation: React.Dispatch<React.SetStateAction<OperationBCI | null>>;
  refetch: () => void;
  activeTab: TabDescriptor | null;
  errors: Record<string, string>;
  setErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  acceptCGV: boolean;
  setAcceptCGV: React.Dispatch<React.SetStateAction<boolean>>;
  printRef?: React.RefObject<HTMLDivElement>;
}

// Routeur d'onglet BCI acheteur : seulement Consultation + Offre (pas d'historique/messagerie/
// evaluation). BCI n'a pas de signature : le lancement de consultation est un PUT direct vers
// /bdci/operation/{id}/consultation (payload mappe), suivi d'un refetch — aucune modale de signature.
const OperationContent: React.FC<OperationContentProps> = ({
  operation,
  setOperation,
  refetch,
  activeTab,
  errors,
  setErrors,
  acceptCGV,
  setAcceptCGV,
  printRef,
}) => {
  const { accepter, refuser } = useOperationBCIActions(operation, refetch);

  const handleLancerConsultation = async (_rang: number): Promise<void> => {
    await lancerConsultation(operation.id, buildConsultationLaunchBody(operation));
    refetch();
  };

  if (!activeTab) return null;

  switch (activeTab.kind) {
    case 'consultation':
      return (
        <OperationConsultation
          commande={operation}
          rang={(activeTab.rang ?? 1) as 1 | 2 | 3}
          errors={errors}
          setErrors={setErrors}
          setCommande={setOperation}
          handleLancerConsultation={handleLancerConsultation}
          handleAccepterCommande={accepter}
          handleRefuserCommande={refuser}
          acceptCGV={acceptCGV}
          setAcceptCGV={setAcceptCGV}
          printRef={printRef}
        />
      );

    case 'offre':
      return (
        <OperationOffre
          commande={operation}
          rang={activeTab.rang ?? 1}
          acceptCGV={acceptCGV}
          setAcceptCGV={setAcceptCGV}
          printRef={printRef}
        />
      );

    default:
      return null;
  }
};

export default OperationContent;
